import { Observable } from 'rxjs';
import { TpvTransaction } from '@app/domain/models/tpv/transaction.model';
import { TpvListQuery, TpvPage } from '@app/domain/models/tpv/tpv-page.model';

/**
 * Filtros de `GET /api/v1/tpv/transactions/`. Todos opcionales y multi-valor
 * (OR dentro del filtro, AND entre filtros). Los valores son las KEYS exactas
 * del contrato en MAYÚSCULAS (p. ej. status=`APROBADA`, no "Aprobada").
 */
export interface TransactionListQuery extends TpvListQuery {
  /** APROBADA·DEVUELTA·RECHAZADA·CANCELADA·CERRADA·RETENIDO */
  status?: string[];
  /** CREDITO·DEBITO·PREPAGO·MESES */
  paymentMethod?: string[];
  /** VISA·MASTERCARD·CARNET·AMEX (el backend lo aplica sobre payment_gateway). */
  cardBrand?: string[];
  /** VENTA·CHECK_IN·CHECK_OUT·REAUTORIZACION */
  operationType?: string[];
  /** PROSA·AMERICAN_EXPRESS·BANREGIO·BROXEL */
  processor?: string[];
  /** id(s) de terminal */
  idTerminal?: string[];
  /** gross_amount >= minAmount */
  minAmount?: number;
  /** gross_amount <= maxAmount */
  maxAmount?: number;
  /** true·false */
  approved?: boolean;
  /**
   * Correo del cliente (`?email=`). Filtro de UN solo valor: a diferencia del
   * resto, el backend no documentó multi-valor para éste, así que no se manda CSV.
   * Pendiente de confirmar con backend si la coincidencia es exacta o parcial y si
   * distingue mayúsculas (en `/payments/charges/` sí se especificó que NO distingue).
   */
  email?: string;
}

/**
 * Port de lectura de transacciones.
 * `externalIdMerchant` (UUID) es OPCIONAL: si se envía, se filtra a ese comercio
 * (`id_merchant`); si se OMITE, el backend devuelve todas las transacciones de los
 * comercios a los que el usuario tiene acceso (scope automático, sin que el front
 * mande la lista). Ver contrato GET /api/v1/tpv/transactions/.
 */
export abstract class TransactionRepository {
  abstract getTransactions(
    externalIdMerchant?: string,
    query?: TransactionListQuery,
  ): Observable<TpvPage<TpvTransaction>>;
}
